module.exports = __webpack_public_path__ + "static/img/icon_join_complete.3902828.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/icon_join_complete.svg
// module id = kt+d
// module chunks = 10